module.exports = __webpack_public_path__ + "img/cloth_g3_pants-03.6ace37b7.svg";